import React from 'react';
import Icon from '../../../icon';
function SaveButtonIcon({ glyph }) {
  return (
    <span className="ws-ui-save-button-icon">
      <Icon glyph={glyph} type="inherit" size="100%" />
    </span>
  );
}

export default SaveButtonIcon;
